import React, { useEffect, Suspense, lazy, useState } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//datefomatter
import { format } from 'date-fns';
//style
import styles from 'src/asset/scss/style/dashboard.module.scss'
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//hook
import useVehicleRegHook from 'src/webapp/hooks/vehicle/vehicleReg.hook';//차량등록
//comp-wrapper
import Section from 'src/webapp/views/wrapper/Section';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import Menu from 'src/webapp/views/component/Menu';
import TitleBar from 'src/webapp/views/component/title/TitleBar';//상단타이틀
import SisData from './comp/SisData';//당일집계내역
import LineChart from './comp/LineChart';//매출현황
import DonutChart from './comp/DonutChartAndButtonArea';//카테고리별 예약비율(**모바일에서 버튼출력)
import ReservList from './comp/ReservList';//당일&익일예약내역

import DateRangeBottomsheet from 'src/webapp/views/component/datepicker/DateRangePicker';//공통 - date-range bottomsheet

//차량등록Comp
const _bsVehicleRegInit     = lazy(() => import('src/webapp/views/vehicle/BsVehicleRegInit'), { ssr: false });//라인차트
const _bsVehicleRegBrand    = lazy(() => import('src/webapp/views/vehicle/BsVehicleRegBrand'), { ssr: false });//라인차트
const _bsVehicleRegModel    = lazy(() => import('src/webapp/views/vehicle/BsVehicleRegModel'), { ssr: false });//라인차트
const _bsVehicleRegSuccess  = lazy(() => import('src/webapp/views/vehicle/BsVehicleRegSuccess'), { ssr: false });//라인차트

export default function Dashboard() {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { isState, partner } = usePartnerStore();
    const { isOpen//팝업오픈여부
        , changeOpenHandler//팝업화면전환핸들러
        , onDismissHandler//팝업off핸들러
        , brandItem//선택브랜드useState
        , handleBrandChange//모델선택핸들러
    } = useVehicleRegHook();
    
    /* =============== 등록된 취급차량갯수(*0일시 차량등록 팝업) =============== */
    const vehicleCntAPI = async () => {
        const DATA = { PARTNER_CD: partner.COMN_CD };
        const result = await axiosPostHandler(`partnerVehicleCountForPartner.do`, DATA);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            if(result.data.CNT > 0) { return; }
            changeOpenHandler("init");
        }
    }
    useEffect(() => {
        if(!isState) { return; }

        vehicleCntAPI();
    }, [isState]);
    /* =============== 등록된 취급차량갯수(*0일시 차량등록 팝업) =============== */
    /* =============== 조회날짜-bottomsheet로 전달 =============== */
    const today = new Date();//오늘날짜
    const [ startDate,setStartDate ] = useState(new Date(today.setDate(today.getDate() - 7)));
    const [ endDate,setEndDate ] = useState(new Date());
    /* =============== 조회날짜-bottomsheet로 전달 =============== */
    /* =============== 날짜선택 팝업오픈여부 =============== */
    const [ datepicker,setDatePicker ] = useState(false);
    const onDatePickerDismissHandler = (value) => {
        setDatePicker(value);
    }
    /* =============== 날짜선택 팝업오픈여부 =============== */

    const handleSuccess = () => {}
    
	return (
		<>
        <Section className={"section sectionContainer"}>
            <Menu />{/* 메뉴바 */}
            <Element tag={`div`} className={`container`}>
                <FixedPanel>
                    <TitleBar title={`매출 관리`} />
                    <Element tag={`div`} className={styles.searchContainer}>
                        <Element tag={`time`}>{format(startDate, 'yyyy.MM.dd') + ' - ' + format(endDate, 'yyyy.MM.dd')}</Element>
                        <Element tag={`button`} anyprop={(e) => onDatePickerDismissHandler(true)}><FontAwesomeIcon icon="fa-light fa-calendar-lines" /></Element>
                    </Element>
                </FixedPanel>
                <FlickPanel>
                    <SisData startDate={startDate} endDate={endDate} />
                    <Element tag={`div`} className={styles.chartAndLogContainer}>
                        <Element tag={`dl`}>
                            <Element tag={`dd`}><LineChart startDate={startDate} endDate={endDate} /></Element>
                            <Element tag={`dd`}><ReservList type={1} /></Element>
                        </Element>
                        <Element tag={`dl`}>
                            <Element tag={`dd`}><DonutChart startDate={startDate} endDate={endDate} /></Element>
                            <Element tag={`dd`}><ReservList type={2} /></Element>
                        </Element>
                    </Element>
                </FlickPanel>
            </Element>
        </Section>

        {/* date-range - bottomsheet */}
        {datepicker ? <DateRangeBottomsheet isOpen={datepicker} onDismiss={onDatePickerDismissHandler} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} minDate={null} maxDate={new Date()} /> : null}

        {/* 차량등록 bottomSheet */}
        {isOpen.init ? <Suspense fallback={null}><_bsVehicleRegInit isOpen={isOpen.init} onDismiss={onDismissHandler} /></Suspense> : null}
        {isOpen.brand ? <Suspense fallback={null}><_bsVehicleRegBrand isOpen={isOpen.brand} onBrand={handleBrandChange} onDismiss={onDismissHandler} /></Suspense> : null}
        {isOpen.model ? <Suspense fallback={null}><_bsVehicleRegModel isOpen={isOpen.model} brand={brandItem} onSuccess={handleSuccess} onDismiss={onDismissHandler} /></Suspense> : null}
        {isOpen.success ? <Suspense fallback={null}><_bsVehicleRegSuccess isOpen={isOpen.success} onDismiss={onDismissHandler} /></Suspense> : null}
		</>
	);
  }